import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FormModalContent } from '../style';
import { BackIconContainer } from '../../style';
import { Text } from '../../../../UI/Text';
import LeaderBoards from '../../../../Containers/LeaderBoards/LeaderBoards';
import { LeaderboardsModalContainer } from './style';
import { handleLoginService } from '../../../../../Services/handleLocalStorage';
import { isEmptyObject } from '../../../../../Utils';
import { chooseWorkoutItemsIds } from '../constants';

const LeaderboardsComponent = withRouter(props => <LeaderBoards {...props} />);

export class ChooseLeaderboardsModal extends Component {
    getPropsForLeaderboards = () => {
        const currentProfileId = handleLoginService.getUserId();
        const {
            workoutLeaderboards,
            leaderboardsType,
            workoutOfTheWeek,
            workoutsOfTheDay,
            workoutIdSelected,
        } = this.props;

        if (workoutLeaderboards)
            if (leaderboardsType === chooseWorkoutItemsIds.WORKOUT_OF_THE_DAY)
                return { specificWorkoutId: workoutsOfTheDay.id };

        if (leaderboardsType === chooseWorkoutItemsIds.CHALLENGE_OF_THE_WEEK)
            return { specificWorkoutId: workoutOfTheWeek.id };

        if (leaderboardsType === chooseWorkoutItemsIds.CUSTOM_WORKOUT) return { specificWorkoutId: workoutIdSelected };

        return { specificProfileId: currentProfileId };
    };

    renderLeaderboards = () => {
        const {
            workoutLeaderboards,
            leaderboardsType,
            workoutOfTheWeek,
            workoutsOfTheDay,
            onSelect,
            initialModalType,
            type,
        } = this.props;

        const Lb = props => (
            <LeaderboardsComponent
                modalType={type}
                initialModalType={initialModalType}
                onSelect={onSelect}
                selectLeaderboardType={type}
                {...this.getPropsForLeaderboards()}
            />
        );

        if (workoutLeaderboards)
            if (leaderboardsType === chooseWorkoutItemsIds.WORKOUT_OF_THE_DAY)
                if (isEmptyObject(workoutsOfTheDay)) return <Text>You don't have a workout of the day</Text>;
                else return <Lb />;

        if (leaderboardsType === chooseWorkoutItemsIds.CHALLENGE_OF_THE_WEEK)
            if (isEmptyObject(workoutOfTheWeek)) return <Text>You don't have a week challenge</Text>;
            else return <Lb />;

        return <Lb />;
    };

    render() {
        const {
            props: { onClose, title },
            renderLeaderboards,
        } = this;

        return (
            <LeaderboardsModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        {title}
                    </Text>

                    <BackIconContainer onClick={onClose}>
                        <i className="fas fa-chevron-left" />
                    </BackIconContainer>

                    {renderLeaderboards()}
                </FormModalContent>
            </LeaderboardsModalContainer>
        );
    }
}

ChooseLeaderboardsModal.defaultProps = {
    type: 0,
    title: 'Choose general leaderboards',
    onClose: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/Modals/ChooseGeneralLeaderboardsModal.js